import api from '@src/lib/api';
import { ResourceFetch, CollectionWrapper, SearchBean } from '@src/meta/types/api';
import config from '@config/config';
import {
  NewOAuthClientDescriptorPayload,
  OAuthClientDescriptor,
  ServerOAuthClientDescriptor,
  UpdateOAuthClientDescriptorPayload,
} from '../../types/oauth-client';

const { GET, POST, PUT, DELETE } = api;

const CLIENT_RESOURCE_BASE_PATH = `${config.identityServiceBasePath}/clients`;

interface ClientResource {
  search: ResourceFetch<
    CollectionWrapper<ServerOAuthClientDescriptor>,
    SearchBean & { accountId: string }
  >;
  create: ResourceFetch<OAuthClientDescriptor, NewOAuthClientDescriptorPayload>;
  update: ResourceFetch<OAuthClientDescriptor, UpdateOAuthClientDescriptorPayload & { id: string }>;
  delete: ResourceFetch<string, { id: string }>;
}

const ClientResource: ClientResource = {
  search: GET(
    `${CLIENT_RESOURCE_BASE_PATH}?withParameters=true&accountId=:accountId&includeDeleted=true`,
  ),
  create: POST(CLIENT_RESOURCE_BASE_PATH),
  update: PUT(`${CLIENT_RESOURCE_BASE_PATH}/:id`),
  delete: DELETE(`${CLIENT_RESOURCE_BASE_PATH}/:id`),
};

export default ClientResource;
